import CryptoJS from 'crypto-js'
//DES解密
export const decryptByDES = (ciphertext, key = 'WDNRTXBRCBFXJBFZ') => {
  if (!ciphertext) {
    return ciphertext
  }
  try {
    let keyHex = CryptoJS.enc.Utf8.parse(key)
    let decrypted = CryptoJS.DES.decrypt({
      ciphertext: CryptoJS.enc.Hex.parse(ciphertext),
    }, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
  } catch (_) {
    return ciphertext
  }
}

